export default from './post-form';



// WEBPACK FOOTER //
// ./app/components/post-form/index.js